<template>
    <organization-reliability-report-controller v-slot:default="orrc">
        <div class="atmo-page-content atmo-client-space">
            <header>
                <h3 class="grey-color mb-4 main_text font-weight-bold fs-28">Проверка контрагентов</h3>
                <p>
                    Скачайте пример отчета по <b><a style="text-decoration: underline; color: var(--green-color)" target="_blank" v-bind:href="orrc.report_example_link">ссылке</a></b
                    >.
                </p>
                <p>
                    Стоимость одно запроса по организации составляет
                    <span v-if="orrc.vmdservice.viewables.financials.is_empty" class="atmo-skeleton-placeholder-item">&emsp;</span>
                    <b v-else><span v-text="orrc.vmdservice.viewables.financials.report_price"></span> руб.</b>
                    Эта сумма будет списана с лицевого счета Вашей организации в момент скачивания отчета. <br />Остаток на лицевом счете составляет:
                    <span v-if="orrc.vmdservice.viewables.financials.is_empty" class="atmo-skeleton-placeholder-item">&emsp;&emsp;</span>
                    <span v-else>{{ orrc.vmdservice.viewables.financials.deposit_balance | formatnumber }}</span> руб.
                </p>
            </header>

            <p v-if="!orrc.is_form_visible && !orrc.vmdservice.viewables.is_loading.financials" class="atmo-error">Остатка на лицевом счете недостаточно для оплаты отчета. Пожалуйста, пополните лицевой счет и перезагрузите эту страницу.</p>

            <main v-if="orrc.is_form_visible">
                <section class="atmo-form__field atmo-inverse">
                    <span v-bind:key="orrc.vmdservice.viewables.refresh_key" class="atmo-input-w-spinner">
                        <clearable-input v-slot:default="ci">
                            <span class="atmo-clearable-input">
                                <input id="orr-inn" v-model="orrc.vmdservice.editable.inn" v-focus v-input-int="true" autocomplete="off" maxlength="12" minlength="10" pattern="\d{10}|\d{12}" required size="14" style="width: auto" type="tel" />
                                <button v-if="!ci.isEmpty()" class="atmo-clear" tabindex="-1" title="Очистить поле ввода" v-on:click="ci.clear"><i class="atmo-icon-close"></i></button>
                            </span>
                        </clearable-input>

                        <transition name="fade">
                            <!-- // NB: To eliminate annoying spinner blinking. -->
                            <div v-if="orrc.vmdservice.viewables.is_loading.organization" class="atmo-spinner">
                                <img alt="Waiting spinner" src="@theme/assets/images/loaders/spinner-sector.svg" />
                            </div>
                        </transition>
                    </span>

                    <label for="orr-inn">Введите ИНН. 10-значный (для организаций) или 12-значный (для ИП).</label>
                </section>

                <p v-if="orrc.is_not_found_message_visble" class="atmo-error">Организация с таким ИНН не найдена.</p>
                <p v-if="!orrc.vmdservice.editable.is_inn_valid" class="atmo-error">ИНН должен содержать 10 или 12 цифр.</p>

                <template v-if="orrc.vmdservice.viewables.is_found">
                    <h6>Найдена организация</h6>
                    <OrganizationInfo.view v-bind:organization="orrc.vmdservice.viewables.organization" />

                    <ul class="atmo-inputs-inline">
                        <li class="atmo-form__field atmo-checkbox">
                            <input id="orr-email" v-model="orrc.vmdservice.editable.has_to_email_report" class="atmo-icon-checkmark" name="orr-email" type="checkbox" />
                            <label for="orr-email">Отправить отчет на email:</label>
                        </li>
                        <li class="atmo-form__field atmo-inverse">
                            <input v-model="orrc.vmdservice.editable.email" required size="50" type="email" v-bind:disabled="!orrc.vmdservice.editable.has_to_email_report" />
                            <p class="atmo-error">Укажите правильный email</p>
                        </li>
                    </ul>

                    <p><i class="atmo-warning atmo-icon-warning"></i>&nbsp;Внимание! Повторное скачивание отчета без оплаты недоступно. <br />Рекомендуем отправить отчет на электронную почту. Для этого установите галочку напротив данной опции выше и укажите актуальный адрес.</p>

                    <button v-bind:disabled="!orrc.vmdservice.editable.is_email_valid || !$store.getters.getCanSign" v-on:click.stop="orrc.invokeSignReportDownloadPopup" class="atmo-button mx-2">Подтвердить</button>
                    <template v-if="!$store.getters.getCanSign">
                        <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                        <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Скачивание отчёта возможно только при авторизации при помощи ЭЦП</span>
                    </template>
                </template>
            </main>
        </div>
    </organization-reliability-report-controller>
</template>

<script>
import Config from '@core/js/ddriven/application/config/Config';
import OrganizationReliabilityReportController from '@core/js/viewmodels/misc/organization-reliability-report/OrganizationReliabilityReportController.viewmodel.ts';
import OrganizationInfoView from 'themes/views/pages/client-space/supplier/organization-reliability-report/OrganizationInfo.partial.view.vue';
import ClearableInput from '@lib/js/src/vue/components/ClearableInput.viewmodel';
import Focus from '@lib/js/src/vue/directives/Focus.directive';

export default {
    directives: {
        focus: new Focus()
    },
    components: {
        'organization-reliability-report-controller': OrganizationReliabilityReportController,
        'clearable-input': ClearableInput,

        'OrganizationInfo.view': OrganizationInfoView
    },
    computed: {
        reliability_report_example() {
            return Config.get('theme.variables.links.other.reliability_report_example');
        }
    }
};
</script>
